import { render, staticRenderFns } from "./PenggalianViewNew.vue?vue&type=template&id=79acdea2&scoped=true&lang=pug&"
import script from "./PenggalianViewNew.vue?vue&type=script&lang=js&"
export * from "./PenggalianViewNew.vue?vue&type=script&lang=js&"
import style0 from "./PenggalianViewNew.vue?vue&type=style&index=0&id=79acdea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79acdea2",
  null
  
)

export default component.exports